export const SKINS_AD_CONTAINER_ID = 'skins_ad';
export const SKINS_AD_TAG = 'Skins AD';
export const SKINS_AD_FEATURE_SWITCH_KEY = 'mockSkinsAdData';
export const IS_PLATFORM_SUPPORT_SKINS_AD = ['FIRETV_HYB'].includes(__OTTPLATFORM__);
export const SKINS_AD_FULLSCREEN_COUNT_DOWN_SECOND = 5;
